<template>
  <div class="layout edit_supply_warp">
    <p>供需：</p>
    <van-field
      class="edit_supply_textarea"
      v-model="business.content"
      :autosize={minHeight:60,maxHeight:150}
      type="textarea"
      placeholder="请输入"
      maxlength="100"
      show-word-limit
    />
    
    <div class="uploading_wrap">
      <div class="img_block" v-for="(item,index) in business.imgList" :key="index" >
        <div class="img_wrap" @click="viewImg(business.imgList,index)">
          <img :src="item" >
        </div>    
        <i class="van-icon van-icon-clear van-uploader__preview-delete" @click="clearImg(index)"></i>      
      </div>
      <div class="img_uploading" @click="setImg" v-if="business.imgList.length<3">
        <i class="van-icon van-icon-plus van-uploader__upload-icon"></i>
      </div>
    </div>
    <span>最多可上传3张图片</span>
    <van-button class="edit_supply_ok" @click="ok" block color="#f85b0f">确定</van-button>
  </div>
</template>

<script>
import {ImagePreview} from "vant";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "editSupply",
  components:{
  },
  data() {
    return {
      business:{          //商机：供需
        content:'',
        imgList:[
          // 'http://img1.imgtn.bdimg.com/it/u=358072697,1063207844&fm=15&gp=0.jpg',
          // 'http://img0.imgtn.bdimg.com/it/u=2533503714,1694698956&fm=15&gp=0.jpg',
          // 'http://img5.imgtn.bdimg.com/it/u=2101489911,309438404&fm=15&gp=0.jpg'
        ]
      },
      imgList:[]
    } 
  },
  computed: {
    ...mapGetters({
      user: "getUserInfo" // 用户身份类别 0：游客、1：普通买家、2：专业买家、3：行业名人、4：展商
    }),
  },
  created(){
    this.getBusiness();
  },
  beforeDestroy(){
    this.$toast.clear();
  },
  methods:{
    ...mapActions({
      editUserRole:'login/editUserRole',
      getUser:'login/getUser',
      wxUpLoadImg:'upload/wxUpLoadImg',
    }),
    //商机（供需）字符串转json
    getBusiness(){
      let data={};
      if(!(Object.prototype.toString.call(this.user.business) === '[object Object]')){
        data=JSON.parse(this.user.business);
      }else{
        data=this.user.business;
      }
      if(data){
        this.business.content=data.content;
        this.business.imgList=data.imgList;
      }
    },
    //预览图片
    viewImg(imgList,index){
      ImagePreview({images: imgList, startPosition: index});
    },
    //删除图片
    clearImg(index){
      this.business.imgList.splice(index,1);
      // console.log(this.business.imgList);
      // console.log(index);
    },
    //上传图片
    async setImg() {  
      const that = this; 
      const callBack = (data) => { 
        console.log('coverImg供需', data);
      };
      const img = await this.wxUpLoadImg(callBack); 
      console.log('供需上传的图片：', img); 
      if(img){
         this.business.imgList.push(img);
      }else{
        // this.business.imgList.push('http://img5.imgtn.bdimg.com/it/u=2101489911,309438404&fm=15&gp=0.jpg')
        this.$toast.fail({
          message:'上传失败',
          closeOnClick :true
        });
      }
    },
    //提交供需修改
    async ok(){
      if(!this.business.content){
        this.$toast.fail('供需不能为空');
        return 
      }
      if((/.*1[3|4|5|7|8][0-9]{9}.*/.test(this.business.content))){
        this.$toast.fail('不能包含手机号');
        return;
      }
      let opt={
        business:JSON.stringify(this.business)
      };
      // console.log(opt);
      let res= await this.editUserRole(opt);
      if(res&&res.result){
        this.$router.go(-1);
      }else{
        this.$toast.fail('修改失败');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit_supply_warp{
  padding:0.18rem  0.24rem 0;
  color: #fff;
  background: #131825;
  p{
    line-height: 1;
    margin-bottom: 0.21rem;
  }
  >span{
    color: #bfbfbf;
    display: block;
  }
  .edit_supply_ok{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0.98rem;
    line-height: 0.98rem;
    span{
      font-size: 0.36rem;
    } 
  }
  .edit_supply_textarea{
    padding: 0.25rem 0.2rem 0.1rem;
    margin-bottom: 0.9rem;
    border-radius: 0.03rem;
    background: #1d2435;
    min-height: 1.3rem;
    overflow-y:initial;
    &::after{
      display: none;
    }
    &::v-deep .van-cell__value{
      .van-field__control{
        line-height: 0.28rem;
        color: #fff;
        word-break:break-all;
        word-wrap:break-word;
        text-align: justify;
      }
      // .van-field__word-limit{
      //   width: 100%;
      //   position: absolute;
      //   bottom: 0;
      // }
    }
    
  }
  .uploading_wrap{
    margin-bottom: 0.25rem;
    display: flex;
    .img_block{
      margin-right:0.2rem;
      cursor: pointer;
      position: relative;
      .img_wrap{
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 1px;
        overflow: hidden;
        img{
          display: block;
          width: 100%;
          height: 100%;
          // object-fit: cover;
        }
      }
      .van-icon{
        background:transparent;
        font-size: 0.35rem;
        top: -0.12rem;
        right: -0.12rem;
        color: #fff;
      }
    }
    .img_uploading{
      margin: 0 0.2rem 0 0;
      background: transparent;
      border: 1px solid #cccccc;
      border-radius: 1px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 1.6rem;
      height: 1.6rem;
    }
  }
  .img_uploading{
    margin-bottom: 0.25rem;
    &::v-deep .van-uploader__preview{
      margin: 0 0.2rem 0 0;
      .van-image{
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 1px;
      }
      .van-icon{
        background:transparent ;
        font-size: 0.35rem;
        top: -0.12rem;
        right: -0.12rem;
        color: #fff;
      }
    }
    &::v-deep .van-uploader__upload{
      margin: 0 0.2rem 0 0;
      background: transparent;
      border: 1px solid #cccccc;
      border-radius: 1px;
    }
  }
}
</style>
